import { render, staticRenderFns } from "./TreatmentGraphV4.vue?vue&type=template&id=25ef0d2c&scoped=true&"
import script from "./TreatmentGraphV4.vue?vue&type=script&lang=ts&"
export * from "./TreatmentGraphV4.vue?vue&type=script&lang=ts&"
import style0 from "./TreatmentGraphV4.vue?vue&type=style&index=0&id=25ef0d2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ef0d2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VIcon,VSelect,VSpacer,VSwitch,VTextField})
